import { z } from 'zod';

import { type SubeventTeamData } from '~/components/BettingInsights/types';

import { type BettingSplitsBet, type BettingSplitsESResult } from '../types.ts';

import { schemaTeam } from './extractSubevent.ts';

const schemaBet = z.object({
	betCount: z.number(),
	betId: z.number(),
	betName: z.string(),
	betPercentage: z.number(),
	bookmakerCode: z.string(),
	line: z
		.object({
			absolute: z.string(),
			name: z.string(),
			sign: z.string(),
		})
		.optional(),
	oddsAmerican: z.string(),
	oddsDecimal: z.number(),
	oddsFractional: z.string(),
	parentBetId: z.number(),
	stakeBetDiff: z.number(),
	stakePercentage: z.number(),
	teamData: z.object({
		home: schemaTeam,
		away: schemaTeam,
	}),
});

export function extractBet(result: BettingSplitsESResult): BettingSplitsBet {
	const parsedBet = schemaBet.safeParse(result);

	if (!parsedBet.success) {
		throw new Error(JSON.stringify(parsedBet.error.flatten().fieldErrors));
	}

	const {
		betCount,
		betId,
		betName,
		betPercentage,
		bookmakerCode,
		line,
		oddsAmerican,
		oddsDecimal,
		oddsFractional,
		parentBetId,
		stakeBetDiff,
		stakePercentage,
		teamData,
	} = parsedBet.data;

	const teamType = Object.entries(teamData ?? {})
		.filter(([_, team]) => team.name === betName)
		.map(([key]) => key as keyof SubeventTeamData)
		.pop();

	return {
		betCount,
		betId,
		betName,
		betPercentage,
		bookmakerCode,
		line,
		oddsAmerican,
		oddsDecimal,
		oddsFractional,
		parentBetId,
		stakeBetDiff,
		stakePercentage,
		...(teamType ? { teamType } : {}),
	};
}
